/**
 * Renders a list of LibGuide resources
 * 
 * Usage: 
 * Pull a list of resources with a given tag:
 * <DLCList tag="Rsearch" limit={5}/>
 * 
 * Pull a list of resources from a fulltext search (contains keywords):
 * <DLCList search="Analysis"/>
 * 
 * Pull a list of resources from a fulltext search within a category: 
 * <DLCList tag="Research" search="citations" />
 */

import React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { array_shuffle } from 'src/uglib_utils/utils';

import * as styles from 'src/uglib_styles/dlcList.module.css'

function DLCList (props) {

    const [apiResponse, setApiResponse] = useState([]);

    useEffect(() => {

        function fetch_learning_objects(tag, search, limit, randomize) {

            const url = 'https://learningcommons.lib.uoguelph.ca/resources.json';
            
            let learning_objects = fetch(url)
                .then(response => response.json())
                .then((learning_objects) => {
                    update_learning_objects(learning_objects, tag, search, limit, randomize);
                })
                .catch(error => console.log(error));
;

            return learning_objects;
        
        }

        function update_learning_objects(learning_objects, tag, search, limit, randomize) {

            let filtered_learning_objects = learning_objects;

            if (tag !== "") {
                filtered_learning_objects = filtered_learning_objects.filter((object) => (object.categories.includes(tag)));
            }

            if (search !== "") {
                filtered_learning_objects = filtered_learning_objects.filter((object) => {
                    const index = (object.title + " " + object.description).toLowerCase();
                    return index.includes(search.toLowerCase());
                })
            }

            if(randomize) {
                filtered_learning_objects = array_shuffle(filtered_learning_objects);
            }

            if (limit !== 0) {
                filtered_learning_objects = filtered_learning_objects.slice(0, limit);
            }

            // Generate an array of React elements, one for each learning object. 
            const learning_object_list = filtered_learning_objects.map((object) => {
                const baseURL = "https://learningcommons.lib.uoguelph.ca";
                const link = baseURL + object.path;
                const image_src = baseURL + object.image;

                return (
                    
                    <React.Fragment key={ object.id }>
                        <li key={ object.id } className={ styles.learning_object }>
                            <a className="dlc-resource" href={ link }> <img src={ image_src } alt={ object.title } /></a>
                        </li>
                    </React.Fragment>
                );
            })
            
            setApiResponse(learning_object_list)
        }

        fetch_learning_objects(props.tag, props.search, props.limit, props.randomize);
    }, [props.tag, props.search, props.limit, props.randomize])

    if ( apiResponse.length === 0 ) {
        return <></>;
    }
    
    // Add classes to enable shrinking, no wrapping
    let list_styles = styles.learning_object_list;
    if (props.shrink) {
        list_styles = [styles.learning_object_list, styles.shrink].join(' ')
    }

    return (<>
        <h2>{props.title}</h2>

        { props.children }
        <ul className={list_styles}>
            { apiResponse }
        </ul>
    </>)
    
}

DLCList.propTypes = {
    tag: PropTypes.string,
    search: PropTypes.string,
    limit: PropTypes.number,
    title: PropTypes.string,
    randomize: PropTypes.bool,
    shrink: PropTypes.bool
}

DLCList.defaultProps = {
    tag: "",
    search: "",
    limit: 3,
    title: "Learn more",
    randomize: false,
    shrink: false
}

export default DLCList